import React from "react";

import { ChevronLeft, ChevronRight } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { ITheme } from "shared/types";

import { StyledPagerButton } from "./styles";

interface PagerButtonProps {
  page?: number;
  isActive?: boolean;
  handleClick?: () => void;
  isPrevious?: boolean;
  isNext?: boolean;
  isDisabled?: boolean;
}

export const PagerButton: React.FC<PagerButtonProps> = ({
  page,
  isActive,
  handleClick,
  isPrevious,
  isNext,
  isDisabled,
  children,
}) => {
  return (
    <StyledPagerButton
      size="xs"
      theme={isActive ? ITheme.tertiary : ITheme.secondary}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {isPrevious && (
        <>
          <Icon as={ChevronLeft} size="xs" />
          <VisuallyHiddenElement>Previous page</VisuallyHiddenElement>
        </>
      )}

      {page && (
        <>
          <VisuallyHiddenElement>Page</VisuallyHiddenElement> {page}
        </>
      )}
      {isActive && <VisuallyHiddenElement>Current page</VisuallyHiddenElement>}
      {isNext && (
        <>
          <Icon as={ChevronRight} size="xs" />
          <VisuallyHiddenElement>Next page</VisuallyHiddenElement>
        </>
      )}
    </StyledPagerButton>
  );
};
